// FIXME menv
export const murmurHashV3 = (data: string, seed: number = 0) => {
    // Convert string to UTF-8 byte array
    const utf8Bytes: number[] = [];
    for (let i = 0; i < data.length; i++) {
        const code = data.charCodeAt(i);
        if (code < 0x80) {
            utf8Bytes.push(code);
        } else if (code < 0x800) {
            utf8Bytes.push(0xc0 | (code >> 6));
            utf8Bytes.push(0x80 | (code & 0x3f));
        } else if (code < 0xd800 || code >= 0xe000) {
            utf8Bytes.push(0xe0 | (code >> 12));
            utf8Bytes.push(0x80 | ((code >> 6) & 0x3f));
            utf8Bytes.push(0x80 | (code & 0x3f));
        } else {
            // Surrogate pair
            i++;
            const hi = code;
            const lo = data.charCodeAt(i);
            const codePoint = 0x10000 + (((hi & 0x3ff) << 10) | (lo & 0x3ff));
            utf8Bytes.push(0xf0 | (codePoint >> 18));
            utf8Bytes.push(0x80 | ((codePoint >> 12) & 0x3f));
            utf8Bytes.push(0x80 | ((codePoint >> 6) & 0x3f));
            utf8Bytes.push(0x80 | (codePoint & 0x3f));
        }
    }

    const len = utf8Bytes.length;
    const c1 = 0xcc9e2d51;
    const c2 = 0x1b873593;
    const r1 = 15;
    const r2 = 13;
    const m = 5;
    const n = 0xe6546b64;

    let hash = seed;

    // Helper function to read 32-bit little-endian integer from byte array
    const readUInt32LE = (bytes: number[], offset: number): number => {
        return (bytes[offset] | (bytes[offset + 1] << 8) | (bytes[offset + 2] << 16) | (bytes[offset + 3] << 24)) >>> 0;
    };

    // Helper function for left rotation
    const rotateLeft = (value: number, amount: number): number => {
        return ((value << amount) | (value >>> (32 - amount))) >>> 0;
    };

    // Process 4-byte chunks
    const nblocks = Math.floor(len / 4);
    for (let i = 0; i < nblocks; i++) {
        let k = readUInt32LE(utf8Bytes, i * 4);

        k = Math.imul(k, c1);
        k = rotateLeft(k, r1);
        k = Math.imul(k, c2);

        hash ^= k;
        hash = rotateLeft(hash, r2);
        hash = Math.imul(hash, m) + n;
    }

    // Process remaining bytes
    const tailStart = nblocks * 4;
    let k1 = 0;

    switch (len & 3) {
        // @ts-expect-error fallthrough
        case 3:
            k1 ^= utf8Bytes[tailStart + 2] << 16;
        // @ts-expect-error fallthrough
        case 2:
            k1 ^= utf8Bytes[tailStart + 1] << 8;
        case 1:
            k1 ^= utf8Bytes[tailStart];
            k1 = Math.imul(k1, c1);
            k1 = rotateLeft(k1, r1);
            k1 = Math.imul(k1, c2);
            hash ^= k1;
    }

    // Finalization
    hash ^= len;
    hash ^= hash >>> 16;
    hash = Math.imul(hash, 0x85ebca6b);
    hash ^= hash >>> 13;
    hash = Math.imul(hash, 0xc2b2ae35);
    hash ^= hash >>> 16;

    // Ensure 32-bit unsigned integer
    return hash >>> 0;
};
